import React from 'react'

export default function CrownBlackIcon({ width = 24, height = 24, className }) {
  return (
    <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 4L5 16H19L22 4L16 11L12 4L8 11L2 4V4M5 20H19" stroke="#0F172A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}
